window.addEventListener('load', function() {
    const productTabs = document.querySelectorAll('.product__summary__tabs__nav__item');
    const productTabContents = document.querySelectorAll('.product__summary__tabs__content__details');

    if (productTabs.length > 0) {
        productTabs.forEach(function(productTab, index) {
            productTab.addEventListener('click', function() {
                const productTabsActive = document.querySelector('.product__summary__tabs__nav__item.v--active');
                const productTabContentsActive = document.querySelector('.product__summary__tabs__content__details.v--active');
                if (productTabContentsActive) {
                    productTabsActive.classList.remove('v--active');
                    productTabContentsActive.classList.remove('v--active');
                }
                const productTabContent = productTabContents[index];
                if (productTabContent) {
                    productTab.classList.add('v--active');
                    productTabContent.classList.add('v--active');
                }
            });
        });
    }

    const productInfoHandle = document.querySelector('.product__info__handle');
    const productInfoWrapper = document.querySelector('.product__info-wrapper');
    const productInfoContainer = document.querySelector('.product__info-container');
    const toggleGiftCardOptionsBtn = document.querySelector('#toggleGiftCardOptionsBtn');

    if (productInfoHandle) {
        productInfoHandle.addEventListener('click', function() {
            productInfoWrapper.classList.toggle('v--collapsed');
        });
    }

    if(productInfoWrapper) productInfoWrapper.addEventListener('click', function(e) {
        productInfoWrapper.classList.toggle('v--collapsed');
    });

    if(productInfoContainer) productInfoContainer.addEventListener('click', function(e) {
        e.stopPropagation();
    });

    if(toggleGiftCardOptionsBtn) toggleGiftCardOptionsBtn.addEventListener('click', function(e) {
        e.preventDefault();
        productInfoWrapper.classList.toggle('v--collapsed');
    });

    const worldLoadingScreen = document.querySelector('#worldLoadingScreen');

    if(worldLoadingScreen) setTimeout(function() {
        worldLoadingScreen.classList.add('v--hidden');
        setTimeout(function() {
            worldLoadingScreen.remove();
        }, 400);
    }, 2000);

    const accordionTabs = document.querySelectorAll('.accordion dl dt');
    const accordionContent = document.querySelectorAll('.accordion dl dd');

    accordionTabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
            tab.classList.toggle('v--active');
            accordionContent[index].classList.toggle('v--active');
        });
    });

    const drawers = this.document.querySelectorAll('.drawer-page');

    if(drawers) drawers.forEach(function(drawer) {
        const closeBtn = drawer.querySelector('.drawer-page__main__header__close-btn');
        
        if(closeBtn) closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            drawer.classList.remove('v--active');
        });
    });

    const drawerTriggers = document.querySelectorAll('.action--open-drawer');

    if(drawerTriggers) drawerTriggers.forEach(function(drawerTrigger) {
        drawerTrigger.addEventListener('click', function(e) {
            e.preventDefault();
            const drawerIdentifier = drawerTrigger.getAttribute('href');
            const drawer = document.querySelector(drawerIdentifier);
            if(drawer) drawer.classList.add('v--active');
        });
    });

    const passwordDrawerTrigger = document.querySelector('.banner a.button[href="#password"]');

    if(passwordDrawerTrigger) passwordDrawerTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        const drawerIdentifier = passwordDrawerTrigger.getAttribute('href');
        const drawer = document.querySelector(drawerIdentifier);
        if(drawer) drawer.classList.add('v--active');
    });

    const newsletterDrawerTrigger = document.querySelector('.multirow a.btn[href="#newsletter"]');

    if(newsletterDrawerTrigger) newsletterDrawerTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        const drawerIdentifier = newsletterDrawerTrigger.getAttribute('href');
        const drawer = document.querySelector(drawerIdentifier);
        if(drawer) drawer.classList.add('v--active');
    });

    const appointmentsDrawerTrigger = document.querySelector('.multirow a.btn[href="#appointments"]');

    if(appointmentsDrawerTrigger) appointmentsDrawerTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        const drawerIdentifier = appointmentsDrawerTrigger.getAttribute('href');
        const drawer = document.querySelector(drawerIdentifier);
        if(drawer) drawer.classList.add('v--active');
    });

    const contactDrawerTrigger = document.querySelector('.pickup_available a[href="#contact"]');

    if(contactDrawerTrigger) contactDrawerTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        const drawerIdentifier = contactDrawerTrigger.getAttribute('href');
        const drawer = document.querySelector(drawerIdentifier);
        if(drawer) drawer.classList.add('v--active');
    });

    const footerHeadings = document.querySelectorAll('.footer-block__heading');

    if (footerHeadings) footerHeadings.forEach(function(footerHeading) {
        footerHeading.addEventListener('click', function() {
            const activeHeading = document.querySelector('.footer-block__heading.v--active');
            const activeContent = document.querySelector('.footer-block--menu .footer-block__details-content.v--active');
            if (activeHeading && activeContent) {
                activeHeading.classList.remove('v--active');
                activeContent.classList.remove('v--active');
            }
            const footerContent = footerHeading.nextElementSibling;
            footerHeading.classList.toggle('v--active');
            footerContent.classList.toggle('v--active');

        });
    });

    // const toggleBlogContentBtns = document.querySelectorAll('.toggle-blog-content-btn');
    // const toggleBlogContentMobileBtns = document.querySelectorAll('.toggle-blog-content-mobile-btn');
    // const blogPostsWrapper = document.querySelector('.blog-articles');
    // const toggleBlogBodyBtns = document.querySelectorAll('.article-card__read-more-btn');

    // const toggleBlogContent = async (e) => {
    //     e.preventDefault();
    //     blogPostsWrapper.classList.add('has--active');
    //     const activeBlogPost = document.querySelector('.blog-articles__article.v--active');
    //     const wrapper = e.target.closest('.blog-articles__article');
    //     if(activeBlogPost) activeBlogPost.classList.remove('v--active');
    //     await wrapper.classList.toggle('v--active');

    //     const blogPosts = document.querySelectorAll('.blog-articles .article:not(.v--active)');
    //     if(blogPosts) blogPosts.forEach(function(blogPost) {
    //         blogPost.addEventListener('click', removeBlogPostActiveState);
    //     });
    // }

    // const removeBlogPostActiveState = () => {
    //     const blogPosts = document.querySelectorAll('.blog-articles .article');
    //     const activeBlogPost = document.querySelector('.blog-articles__article.v--active');
    //     if(activeBlogPost) activeBlogPost.classList.remove('v--active');
    //     blogPostsWrapper.classList.remove('has--active');

    //     blogPosts.forEach((blogPost) => {
    //         blogPost.removeEventListener('click', removeBlogPostActiveState);
    //     });
    // }

    // if (toggleBlogContentBtns) toggleBlogContentBtns.forEach(function(toggleBlogContentBtn) {
    //     toggleBlogContentBtn.addEventListener('click', toggleBlogContent);
    // });

    // if (toggleBlogContentMobileBtns) toggleBlogContentMobileBtns.forEach(function(toggleBlogContentMobileBtn) {
    //     toggleBlogContentMobileBtn.addEventListener('click', toggleBlogContent);
    // });

    // if (toggleBlogBodyBtns) toggleBlogBodyBtns.forEach(function(toggleBlogContentBtn) {
    //     toggleBlogContentBtn.addEventListener('click', function(e) {
    //         e.preventDefault();
    //         const activeBlogPost = document.querySelector('.blog-articles__article.v--active');
    //         if(activeBlogPost) activeBlogPost.classList.add('v--read-more');
    //     });
    // });

    // const targetElement = document.querySelector('slider-component');

    // const handleIntersection = (entries, observer) => {
    //     entries.forEach(entry => {
    //         let interval = null;
    //         if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
    //             entry.target.scrollBy({
    //                 left: 100,
    //                 top: 0,
    //                 behavior: 'smooth'
    //             });

    //             interval = setTimeout(function() {
    //                 entry.target.scrollBy({
    //                     left: -100,
    //                     top: 0,
    //                     behavior: 'smooth'
    //                 });
    //             }, 500);
    //         } else if (!entry.isIntersecting && entry.intersectionRatio < 0.5) {
    //             clearInterval(interval);
    //         }
    //     });
    // };

    // const options = {
    //     root: null, // default is the viewport
    //     rootMargin: '0px', // default
    //     threshold: 0.5 // Trigger callback when 50% of the target is visible
    // };

    // const observer = new IntersectionObserver(handleIntersection, options);

    // if (targetElement) {
    //     observer.observe(targetElement);
    // }

    const toggleProductGridColumnsBtb = document.getElementById('toggleProductGridColumnsBtb');
    const productGrid = document.getElementById('product-grid');

    if (toggleProductGridColumnsBtb && productGrid) toggleProductGridColumnsBtb.addEventListener('click', function(e) {
        e.preventDefault();
        productGrid.classList.toggle('v--min-columns');
    });

    const productQuickAddPopupOptions = document.querySelectorAll('.product-quick-add-popup-variants-options--option');

    if (productQuickAddPopupOptions) productQuickAddPopupOptions.forEach(function(option) {
        option.addEventListener('click', function(e) {
            e.preventDefault();
            const quickAddPopups = document.querySelectorAll('.product-quick-add-popup');
            const idInput = document.getElementById('ProductQuickAddValue-'+option.getAttribute('data-product-id'));
            if(idInput) idInput.value = option.getAttribute('data-variant-id');
            const form = document.getElementById('ProductQuickAddForm-'+option.getAttribute('data-product-id'));
            if(form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            quickAddPopups.forEach(function(quickAddPopup) {
                quickAddPopup.classList.remove('v--active');
            });
        });
    });

    const toggleProductQuickAddPopup = document.querySelectorAll('.product-toggle-quick-add-button');

    if (toggleProductQuickAddPopup) toggleProductQuickAddPopup.forEach(function(toggleButton) {
        toggleButton.addEventListener('click', function(e) {
            e.preventDefault();
            toggleButton.nextElementSibling.classList.add('v--active');
        });
    });

    const element = document.getElementById('productInfo'); // Or document.body

    if(element) {
        let startY = 0;

        element.addEventListener('touchstart', (e) => {
            startY = e.touches[0].clientY;
        });

        element.addEventListener('touchend', (e) => {
            const endY = e.changedTouches[0].clientY;
            const deltaY = startY - endY; // Positive for swipe up

            const swipeThresholdUp = 25; // Adjust as needed
            const swipeThresholdDown = -25; // Adjust as needed

            if (deltaY > swipeThresholdUp) {
                productInfoWrapper.classList.toggle('v--collapsed');
            } else if (deltaY < swipeThresholdDown) {
                productInfoWrapper.classList.toggle('v--collapsed');
            }
        });

        // Optional: Prevent default touchmove behavior for smoother experience
        element.addEventListener('touchmove', (e) => {
            e.preventDefault(); // Uncomment if you need to prevent scrolling during swipe
        });
    }

});

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}